<template>
	<div>
		<div class="page">
			<header>
				<nav class="uk-navbar-container" uk-navbar="mode: click">
					<a class="uk-navbar-item uk-logo header-logo" href="/">
						<img :src="require('@/assets/img/logo.png')" alt=""/>
					</a>
					<div class="small-main-menu">
						<div class="uk-navbar-left">
							<ul class="uk-navbar-nav">
								<li>
									<a href="#" class="icon-menu" uk-icon="chevron-down"></a>
									<div class="uk-navbar-dropdown">
										<div class="service-menu">
											<nav class="uk-navbar-container uk-margin uk-navbar-transparent"
												 uk-navbar="mode: click;">
												<div class="uk-navbar-left">
													<ul class="uk-list">
														<li>
															<Languages/>
														</li>
														<li><a @click="logout">{{ $t('logout') }}</a></li>
													</ul>
												</div>
											</nav>
										</div>
									</div>
								</li>
							</ul>
						</div>
					</div>
					<div class="main-menu-profile">
						<div class="uk-navbar-right">
							<ul class="uk-navbar-nav">
								<Languages :wrapper="false"/>
								<li>
									<a href="#" uk-icon="user" class="user-profile"></a>
									<div class="uk-navbar-dropdown">
										<ul class="uk-nav uk-navbar-dropdown-nav">
											<li @click="logout"><a href="#">{{ $t('logout') }}</a></li>
										</ul>
									</div>
								</li>
							</ul>
						</div>
					</div>
				</nav>

			</header>
			<div class="page_content container-fluid">
				<router-view name="attach"></router-view>
			</div>
		</div>
		<Footer/>
	</div>
</template>
<script>
import Header from 'components/Header'
import Footer from 'components/Footer'
import Languages from 'components/languages-switch/Languages'
import { FULL_LOGOUT } from 'actions/authentication'
export default {
	name: 'layout',
	components: {
		Header,
		Footer,
		Languages
	},
	methods: {
		logout: function () {
			this.$store.dispatch(FULL_LOGOUT).then(() => {
				this.$router.push('/')
			})
		}
	}
}
</script>
